import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import Headers from "../Components/Headers";
import Footer from "../Components/Footers";

const video = {
  title: "Rules to Break",
  description:
    "A visual work questioning inherited systems, authority, and the rules we are taught to obey.",
  thumbnail:
    "https://trialbucket.s3.ap-south-1.amazonaws.com/Screenshot+2026-01-07+101628.png",
  videoUrl:
    "https://trialbucket.s3.ap-south-1.amazonaws.com/9116112-uhd_3840_2160_25fps.mp4",
};

const VideoGallery = () => {
  const [searchParams] = useSearchParams();
  const [activeVideo, setActiveVideo] = useState(null);
  const [allowed, setAllowed] = useState(false);
  const [viewSaved, setViewSaved] = useState(false);

  const user = JSON.parse(localStorage.getItem("user_auth"));

  // ✅ Verify Stripe if redirected back with session_id
  useEffect(() => {
    const sessionId = searchParams.get("session_id");

    if (sessionId && user) {
      fetch("/api/video/verify", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: sessionId,
          email: user.email,
          username: user.username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.allowed) setAllowed(true);
        });
    }
  }, []);

  // ✅ Check access on normal load
  useEffect(() => {
    if (!user) return;

    fetch("/api/video/has-access", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: user.email }),
    })
      .then((res) => res.json())
      .then((data) => setAllowed(data.allowed));
  }, []);

  // 💳 Rent video
  const rentVideo = async () => {
    const res = await fetch("/api/video/rent", {
      method: "POST",
    });
    const data = await res.json();
    window.location.href = data.url;
  };

  // 👁️ Save view once
  const handlePlay = async () => {
    if (viewSaved || !user) return;

    await fetch("/api/video/view", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: user.email,
        username: user.username,
      }),
    });

    setViewSaved(true);
  };

  return (
    <>
      <Headers />

      <div className="video-page">
        <h1 className="page-title">Video</h1>

        <div
          className="video-card"
          onClick={() => {
            if (allowed) setActiveVideo(video);
            else rentVideo();
          }}
        >
          <img src={video.thumbnail} alt={video.title} />
          <h2>{video.title}</h2>
          <p>{video.description}</p>
          {!allowed && <button>Rent to Watch</button>}
        </div>
      </div>

      {activeVideo && (
        <div className="video-overlay">
          <div className="video-modal">
            <button onClick={() => setActiveVideo(null)}>✕</button>

            <video
              src={activeVideo.videoUrl}
              controls
              autoPlay
              onPlay={handlePlay}
              className="video-player"
            />
          </div>
        </div>
      )}
      <div className="footerBox">
      <p>Powered by <span>BLACKBOX CLASSROOM</span></p>
    </div>

      <Footer />
    </>
  );
};

export default VideoGallery;
